﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { TiendasFiltersDef } from "./TiendasFiltersDef";


export class TiendasFilters extends Entity<TiendasFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new TiendasFiltersDef(), parentKeys);
        super.Form = import('./TiendasFiltersForm').then((module) => module.TiendasFiltersForm);
        this.Title = "Filtros";
    }
}